import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import Colors from '@components/shared/Colors';
import Text from '@components/shared/Text';
import { P, H, H1, H2, H3 } from '@components/shared/Typography';
import Minus from '@images/icon-minus.svg';
import Plus from '@images/plus2.svg';

interface Props {
  isSelected: boolean;
  handleSetSelectedIndex: (index: number) => void;
  title: string;
  description: string;
  index: number;
}

const TourItem: React.FC<Props> = ({ isSelected, handleSetSelectedIndex, title, description, index }) => {
  const ariaIndex = `faq${index}_desc`;
  const [innerHeight, setInnerHeight] = useState(0);
  const textToMeasure = useRef<any>(null);

  useEffect(() => {
    setInnerHeight(textToMeasure.current.clientHeight + 3);
  }, []);

  return (
    <>
      <DT onClick={() => handleSetSelectedIndex(index)}>
        <Button aria-expanded={isSelected} aria-controls={ariaIndex}>
          <TitleText>{title}</TitleText>
          {isSelected ? <IconMinus /> : <IconPlus />}
        </Button>
      </DT>
      <DD isSelected={isSelected} DDHeight={innerHeight}>
        <div ref={textToMeasure} id={ariaIndex}>
          <Text text={description} />
        </div>
      </DD>
      <Line />
    </>
  );
};

export default TourItem;

const DT = styled.dt`
  @media only screen and (max-width: 768px) {
    font-size: 16px;
  }
`;

const Button = styled.button`
  border: none;
  padding: 19px 20px 19px 0;
  background: none;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  &:hover {
    cursor: pointer;
  }
  @media only screen and (min-width: 769px) {
    &:focus {
      outline: 0;
    }
  }
`;

const TitleText = styled.p`
  font-family: 'BrownStd';
  color: inherit;
  line-height: 1.25;
  font-weight: 900;
  text-transform: uppercase;
  max-width: 70%;
  font-size: 13px;
  text-align: left;
  letter-spacing: 1.5px;
  color: ${Colors.navyBlue}!important;
`;

const IconPlus = styled(Plus)`
  margin-top: 5px;

  & path {
    fill: rgba(0, 0, 0, 0.3);
  }
`;

const IconMinus = styled(Minus)`
  margin-top: 11.5px;

  & path {
    fill: rgba(0, 0, 0, 0.3);
  }
`;

interface IDD {
  isSelected: boolean;
  DDHeight: number;
}

const DD = styled.dd`
  margin: ${(props: IDD) => (props.isSelected ? '0 10px 24px 0' : '0 10px 0 0')};
  overflow: hidden;
  transition: height 0.2s ease-in-out, margin 0.2s ease-in-out;
  height: ${(props) => (props.isSelected ? `${props.DDHeight}px` : 0)};

  & p {
    color: inherit;
  }
`;

const Line = styled.hr`
  width: 100%;
  border: none;
  border-top: solid 1px rgba(0, 0, 0, 0.5);
  height: 1px;
`;
